/**
 * Determines the degree difference between the center and a given position
 *
 * @param {Object} center the center position, including X and Y
 * @param {Object} position the current position, including X and Y
 * @returns {number}
 */
export const getRadsFromCenter = (center, position) => {
  const { x: centerX, y: centerY } = center;
  const { x: posX, y: posY } = position;

  return Math.atan2(posY - centerY, posX - centerX);
};
